import Accordion from 'components/Common/Accordion/Accordion';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import isDesktop from 'store/app/selector/isDesktop';
import getDesignedProduct from 'store/product/selector/getDesignedProduct';
import styles from './DesignDetails.module.scss';

const DesignDetails = () => {
  const { t } = useTranslation();
  const [shownTags, setShownTags] = useState(10);
  const isDesktopDevice = useSelector(isDesktop);
  const productData = useSelector(getDesignedProduct);
  const { designDescription } = productData?.content || {};

  if (!productData || !designDescription) return null;

  const allTags = designDescription.split(',').map((tag) => tag.trim().replaceAll('-', ' '));
  const showMoreHandler = () => setShownTags(allTags.length);

  return (
    <Accordion expanded title={t('txt_product_page_related_searches')} titleClassName={styles.title}>
      <div className={styles.tags}>
        {allTags.slice(0, shownTags).map((tag) => (
          <Link to={`/search?query=${tag}&pptagclick=true`} key={tag}>
            <OpButton size="small" variant="secondary" className={styles.tag}>
              <OpText variant="body-small-medium" className={styles.tagText}>
                {tag}
              </OpText>
            </OpButton>
          </Link>
        ))}
        {shownTags < allTags.length && (
          <OpButton size="small" icon-left="plus" variant="text" onClick={showMoreHandler}>
            {isDesktopDevice && t('txt_show_more')}
          </OpButton>
        )}
      </div>
    </Accordion>
  );
};

export default DesignDetails;
